import {
  Address,
  addressToMultilineAddress,
  addressToString,
  isUndefined,
} from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectEditablePropertyDataEntities } from './editablePropertyDataSelectors.ts';

export const selectPropertyIdentificationEntities = createSelector(
  [selectEditablePropertyDataEntities],
  (editablePropertyDataEntities) =>
    Object.fromEntries(
      Object.entries(editablePropertyDataEntities).map(([id, editableData]) => [
        id,
        { id, ...editableData.propertyIdentification },
      ]),
    ),
);

export const selectPropertyIdentificationById = createSelector(
  [selectPropertyIdentificationEntities, (_state, id: string) => id],
  (propertyIdentificationEntities, id) => propertyIdentificationEntities[id],
);

export const selectAllPropertyIdentification = createSelector(
  [selectPropertyIdentificationEntities],
  (propertyIdentificationEntities) => Object.values(propertyIdentificationEntities),
);

export const selectAddress = createSelector(
  [selectPropertyIdentificationEntities, (_state, id: string) => id],
  (propertyIdentificationEntities, id): Address => {
    const propertyIdentification = propertyIdentificationEntities[id];

    if (isUndefined(propertyIdentification) || isUndefined(propertyIdentification.address))
      return {};

    return propertyIdentification.address;
  },
);

export const selectMultilineAddress = createSelector([selectAddress], (address) =>
  addressToMultilineAddress(address),
);

export const selectSubjectAddress = createSelector(
  [selectPropertyIdentificationEntities],
  (propertyIdentification): string => {
    const subjectPropertyIdentification = propertyIdentification.subject;
    if (
      isUndefined(subjectPropertyIdentification) ||
      isUndefined(subjectPropertyIdentification.address)
    )
      return '';

    return addressToString(subjectPropertyIdentification.address);
  },
);
